import React from 'react';
// ⚠️ Same character file as MascotCorner, just scaled bigger via CSS
import character from '../assets/character.png';
import './MascotCenter.css';

export default function MascotCenter({ text, onDismiss }) {
  return (
    <div className="mascot-center__backdrop" onClick={onDismiss}>
      <div
        className="mascot-center"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <img className="mascot-center__character" src={character} alt="" aria-hidden="true" />
        <div className="mascot-center__paper">
          <button className="mascot-center__close" onClick={onDismiss} aria-label="Dismiss">
            ×
          </button>
          <p className="mascot-center__text">{text}</p>
        </div>
      </div>
    </div>
  );
}